<template>
  <section class="cycle-routes">
    <translate tag="h3"> Cycle routes </translate>
    <i18n-t tag="p" keypath="Find {localRoutes}">
      <template #localRoutes>
        <translate
          tag="a"
          :href="cycleRoutesLink"
          rel="nofollow"
          target="_blank"
        >
          local routes on the National Cycle Network
        </translate>
      </template>
    </i18n-t>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { getPointFromStringOrDefault } from '~/utility/geo/latLng'

@Component
class CampsiteCycleRoutes extends Vue {
  @Prop({ required: true })
  point: string

  get cycleRoutesLink() {
    const point = getPointFromStringOrDefault(this.point)
    // tslint:disable-next-line
    return (
      'https://osmaps.ordnancesurvey.co.uk/ncn/' +
      `${point.lat},${point.lng},14`
    )
  }
}

export default toNative(CampsiteCycleRoutes)
</script>
